import React from "react";
import ReactDOM from "react-dom/client";
import { BrowserRouter } from "react-router-dom";

import App from "./App";
import { ApiProvider } from "./context/ApiContext";
import { AuthProvider } from "./context/AuthContext";
import { PropertiesProvider } from "./context/PropertiesContext";

ReactDOM.createRoot(document.getElementById("root")).render(
  <React.StrictMode>
    <ApiProvider>
      <AuthProvider>
        <PropertiesProvider>
          <BrowserRouter>
            <App />
          </BrowserRouter>
        </PropertiesProvider>
      </AuthProvider>
    </ApiProvider>
  </React.StrictMode>
);
